function progressWrapper() {
    return {
        componentName: 'progressWrapper',
        baseStyle: {
            overflow: 'hidden',
            borderRadius: '9999px',
            width: '100%'
        }
    };
}

export { progressWrapper as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZ3Jlc3NXcmFwcGVyLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdGhlbWUvY29tcG9uZW50cy9wcm9ncmVzc1dyYXBwZXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgQ29tcG9uZW50U3R5bGUgfSBmcm9tICcuLi90eXBlcyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHByb2dyZXNzV3JhcHBlcigpOiBDb21wb25lbnRTdHlsZSB7XG4gIHJldHVybiB7XG4gICAgY29tcG9uZW50TmFtZTogJ3Byb2dyZXNzV3JhcHBlcicsXG4gICAgYmFzZVN0eWxlOiB7XG4gICAgICBvdmVyZmxvdzogJ2hpZGRlbicsXG4gICAgICBib3JkZXJSYWRpdXM6ICc5OTk5cHgnLFxuICAgICAgd2lkdGg6ICcxMDAlJ1xuICAgIH1cbiAgfTtcbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFYyxTQUFVLGVBQWUsR0FBQTtJQUNyQyxPQUFPO0FBQ0wsUUFBQSxhQUFhLEVBQUUsaUJBQWlCO0FBQ2hDLFFBQUEsU0FBUyxFQUFFO0FBQ1QsWUFBQSxRQUFRLEVBQUUsUUFBUTtBQUNsQixZQUFBLFlBQVksRUFBRSxRQUFRO0FBQ3RCLFlBQUEsS0FBSyxFQUFFO0FBQ1I7S0FDRjtBQUNIOzs7OyJ9
